module.exports = __webpack_public_path__ + "static/media/services_bg.c7d7039b.jpg";